import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { assessmentApi } from '../../services/assessmentApi';
import { UpdateAssessment } from '../../dtos/Assessments/index';
import { assessmentKeys } from './useGetAssessment';

export function useUpdateAssessment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Omit<UpdateAssessment, 'id'> }) =>
      assessmentApi.update(id, data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully updated assessment');
        // Invalidate all assessment queries to refetch from server
        queryClient.invalidateQueries({ queryKey: assessmentKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to update assessment'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to update assessment'}`);
    },
  });
}
